import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import hero from "../assets/hero.jpg";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const faqs = [
    {
      question: "Quel est le coût du kit testeur?",
      answer: "Le kit testeur est proposé à un tarif préférentiel de 1300€ au lieu de 1900€ pour nos bêta-testeurs. Ce prix inclut l'ensemble du système, les graines, les alevins, la nourriture pour 3 mois et le support premium.",
    },
    {
      question: "Ai-je besoin d'expérience en aquaponie?",
      answer: "Absolument pas ! Notre système est conçu pour être accessible aux débutants. Vous recevrez un guide complet, des tutoriels vidéo et un support personnalisé pour vous accompagner dans votre démarrage.",
    },
    {
      question: "Combien d'espace est nécessaire?",
      answer: "Le système nécessite un espace de 4m² minimum. Il peut être installé sur une surface plate dans un jardin ou sur une terrasse.",
    },
    {
      question: "Puis-je vraiment consommer les produits?",
      answer: "Oui, absolument ! Les poissons et légumes produits sont entièrement comestible et de qualité bio. Le système n'utilise aucun produit chimique et produit des aliments plus sains que ceux du commerce.",
    },
    {
      question: "Quelle est la durée de l'engagement?",
      answer: "La phase de test dure 6 mois. Vous pouvez arrêter à tout moment, mais nous espérons que vous resterez pour nous aider à améliorer le système et profiter de vos récoltes !",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-aquagreen/20 via-transparent to-blue-900/20" />
        <img
          src={hero}
          alt="Système aquaponique"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60 backdrop-blur-md" />
      </div>
      
      <div className="relative max-w-4xl mx-auto px-6">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-aquagreen mb-6">
            Questions fréquentes
          </h2>
          <p className="text-xl text-aquacream max-w-3xl mx-auto">
            Toutes les réponses à vos questions sur notre système d'aquaponie
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="space-y-4"
        >
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ delay: 0.1 * index, duration: 0.5 }}
              className="bg-aquacream rounded-2xl shadow-lg overflow-hidden border border-gray-100"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full p-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-300"
              >
                <h3 className="text-lg font-semibold text-aquablue pr-4">
                  {faq.question}
                </h3>
                <motion.div
                  animate={{ rotate: openIndex === index ? 45 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="flex-shrink-0"
                >
                  <svg
                    className="w-6 h-6 text-aquagreen"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                </motion.div>
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-6 text-aquagray leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;